import React from 'react';
import { Info } from './Info';

const StaticInfo = ({ children }) => (
  <Info message={children} />
);

export default StaticInfo; 
